import confetti from "canvas-confetti";

const BRAND = ["#00665B", "#0205F4", "#0818A8", "#FF5F1F", "#D9D9D9"];

function reduced() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true
  );
}

/**
 * A short, brand-coloured burst for genuine wins (profile saved, test done).
 * Silent no-op when the learner asked for reduced motion.
 */
export function celebrate(intensity: "small" | "big" = "small") {
  if (reduced()) return;
  const count = intensity === "big" ? 120 : 60;
  confetti({
    particleCount: count,
    spread: intensity === "big" ? 90 : 62,
    startVelocity: intensity === "big" ? 45 : 32,
    origin: { y: 0.7 },
    colors: BRAND,
    scalar: 0.9,
    disableForReducedMotion: true,
  });
}
